export const SaleProductRowSkeleton = () => {
  return (
    <div
      className="my-4 w-full animate-pulse border-b border-gray-200 pb-4"
      aria-hidden="true"
    >
      <div className="flex flex-row space-x-4">
        <div className="h-[86px] w-[52px] flex-shrink-0 rounded bg-gray-200 md:h-[167px] md:w-[128px]" />
        <div className="min-w-0 flex-1 space-y-3 pt-1">
          <div className="h-6 w-3/4 rounded bg-gray-200 md:h-7" />
          <div className="h-4 w-1/3 rounded bg-gray-100" />
          <div className="hidden space-y-2 md:block">
            <div className="h-3 w-full rounded bg-gray-100" />
            <div className="h-3 w-5/6 rounded bg-gray-100" />
          </div>
          <div className="h-5 w-24 rounded bg-gray-200" />
        </div>
      </div>
    </div>
  )
}
